/**
 * api接口统一管理
 */
import axios from "../common/axios"
import baseUrl from "./baseUrl";
import Qs from "qs"

const api = {
    //登录
    login(params) {
        return axios.post(`${baseUrl.mgrUserInf}/login`, Qs.stringify(params));
    },
    //登出
    logout() {
        return axios.post(`${baseUrl.mgrUserInf}/logout`);
    },
    //登录以后获取用户信息
    userInf() {
        return axios.post(`${baseUrl.mgrUserInf}/getUserInf`);
    },
    //用户修改密码
    updateUserPass(params) {
        return axios.post(`${baseUrl.mgrUserInf}/updateUserPass`, Qs.stringify(params));
    },
    //获取文章管理
    getArticleContentManager(params) {
        return axios.post(`${baseUrl.mgrArticleInf}/getArticleContentManager`, Qs.stringify(params));
    },
    //获取活动内容总页数
    getArticleContentTotal(params) {
        return axios.post(`${baseUrl.mgrArticleInf}/getArticleContentTotal`, Qs.stringify(params));
    },
    //删除活动
    deleteArticle(params) {
        return axios.post(`${baseUrl.mgrArticleInf}/deleteArticle`, Qs.stringify(params));
    },
    //添加新活动
    addNewArticle(params) {
        return axios.post(`${baseUrl.mgrArticleInf}/addNewArticle`, params, {
            //添加请求头
            headers: {"Content-Type": "multipart/form-data"}
        });
    },
    //获取文章信息
    getArticleInf(params) {
        return axios.post(`${baseUrl.mgrArticleInf}/getArticleInf`, Qs.stringify(params));
    },
    //提交修改文章信息
    updateArticle(params) {
        return axios.post(`${baseUrl.mgrArticleInf}/updateArticle`, params, {
            //添加请求头
            headers: {"Content-Type": "multipart/form-data"}
        });
    },
    //获取用户
    getAccountList(params) {
        return axios.post(`${baseUrl.mgrUserInf}/getAccountList`, Qs.stringify(params));
    },
    //获取角色信息用于展示下拉框
    getRoleInf() {
        return axios.post(`${baseUrl.mgrRoleInf}/getRoleInf`)
    },
    //添加新用户
    insertUser(params) {
        return axios.post(`${baseUrl.mgrUserInf}/insertUser`, Qs.stringify(params));
    },
    //更新用户信息
    updateUserInf(params) {
        return axios.post(`${baseUrl.mgrUserInf}/updateUserInf`, Qs.stringify(params));
    },
    //重置用户密码
    resetPass(params) {
        return axios.post(`${baseUrl.mgrUserInf}/resetPass`, Qs.stringify(params));
    },
    //删除用户
    deleteUser(params) {
        return axios.post(`${baseUrl.mgrUserInf}/deleteUser`, Qs.stringify(params));
    },
    //获取角色信息表格
    getRoleInfTable(params) {
        return axios.post(`${baseUrl.mgrRoleInf}/getRoleInfTable`, Qs.stringify(params));
    },
    //获取所有权限 用于修改权限
    getLimitInf() {
        return axios.post(`${baseUrl.mgrLimitInf}/getLimitInf`);
    },
    //添加角色
    insertRole(params) {
        return axios.post(`${baseUrl.mgrRoleInf}/insertRole`, Qs.stringify(params))
    },
    //获取角色权限
    getRoleLimit(params) {
        return axios.post(`${baseUrl.mgrRoleLimit}/getRoleLimit`, Qs.stringify(params))
    },
    //更新角色信息
    updateRoleInf(params) {
        return axios.post(`${baseUrl.mgrRoleInf}/updateRoleInf`, Qs.stringify(params))
    },
    //删除角色
    deleteRoleInf(params) {
        return axios.post(`${baseUrl.mgrRoleInf}/deleteRoleInf`, Qs.stringify(params))
    },
    //获取用户权限信息
    getUserLimit() {
        return axios.post(`${baseUrl.mgrLimitInf}/getUserLimit`);
    },
    //获取预约表
    getReservationTable(params) {
        return axios.post(`${baseUrl.mgrReservation}/getReservationTable`, Qs.stringify(params));
    },
    //获取预约表
    changeReservationState(params) {
        return axios.post(`${baseUrl.mgrReservation}/changeReservationState`, Qs.stringify(params));
    },
    //获取导航配置
    getFrontNavigation() {
        return axios.post(`${baseUrl.mgrFrontNavigation}/getFrontNavigation`);
    },
    //获取导航配置
    updateFrontNavigation(params) {
        return axios.post(`${baseUrl.mgrFrontNavigation}/updateFrontNavigation`, Qs.stringify(params));
    },
    //获取轮播图集合
    getRotationChart() {
        return axios.post(`${baseUrl.mgrRotationChart}/getRotationChart`);
    },
    //更新轮播图地址
    updateRotationChart(params) {
        return axios.post(`${baseUrl.mgrRotationChart}/updateRotationChart`, Qs.stringify(params));
    },
    deleteRotationChart(params){
        return axios.post(`${baseUrl.mgrRotationChart}/deleteRotationChart`, Qs.stringify(params));
    },
    //提交修改文章信息
    insertRotationChart(params) {
        return axios.post(`${baseUrl.mgrRotationChart}/insertRotationChart`, params, {
            //添加请求头
            headers: {"Content-Type": "multipart/form-data"}
        });
    },


};

export default api;
